import React from 'react';
import { TableCell } from '@mui/material';
import { PassFailChip } from './PassFailChip';

type PassFailStatusCellProps = {
  error: number | null;
  tolerance: number;
  section?: 'asFound' | 'asLeft';
};

export const PassFailStatusCell: React.FC<PassFailStatusCellProps> = ({
  error,
  tolerance,
  section
}) => {
  const getCellBackground = () => {
    if (section === 'asFound') {
      return {
        backgroundColor: 'rgba(33, 150, 243, 0.02)',
        borderRight: '2px solid rgba(33, 150, 243, 0.2)'
      };
    }
    if (section === 'asLeft') {
      return {
        backgroundColor: 'rgba(76, 175, 80, 0.02)',
        borderRight: '2px solid rgba(76, 175, 80, 0.2)'
      };
    }
    return {};
  };

  return (
    <TableCell align="center" sx={getCellBackground()}>
      {error !== null && <PassFailChip error={error} tolerance={tolerance} />}
    </TableCell>
  );
};
